import { render, staticRenderFns } from "./goodCashier.vue?vue&type=template&id=8b7c087c&scoped=true"
import script from "./goodCashier.vue?vue&type=script&lang=js"
export * from "./goodCashier.vue?vue&type=script&lang=js"
import style0 from "./goodCashier.vue?vue&type=style&index=0&id=8b7c087c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c087c",
  null
  
)

export default component.exports